import { LessonReadyRow, LessonOptionsDropdown } from 'components/lesson-builder/components/lesson-status'
import styles from 'css/components/lesson-builder/lesson-builder-header.module.css'

interface LessonBuilderHeaderProps {
  unapprovedCount: number
  allApproved: boolean
  lessonName: string
  setShowAssignClassOverlay: (show: boolean) => void
  isClassAssigned: boolean
  assignedClassName?: string
  gradeBand?: string
  hasResults?: boolean
  onLaunchLesson: () => void
  onShowStudentLogins: () => void
  onCopyToClass: () => void
  onReassign: () => void
  onPrintDraft: () => void
  onPrintAnswerKey: () => void
  onPrintWorksheets: () => void
  teachStatus: string
  isRenaming?: boolean
  renamingValue?: string
  onStartRename?: () => void
  onRenamingValueChange?: (value: string) => void
  onConfirmRename?: () => void
  onCancelRename?: () => void
}

export const LessonBuilderHeader: React.FC<LessonBuilderHeaderProps> = ({
  allApproved,
  unapprovedCount,
  lessonName,
  teachStatus,
  isClassAssigned,
  assignedClassName,
  gradeBand,
  hasResults,
  setShowAssignClassOverlay,
  onLaunchLesson,
  onShowStudentLogins,
  onCopyToClass,
  onReassign,
  onPrintDraft,
  onPrintAnswerKey,
  onPrintWorksheets,
  isRenaming,
  renamingValue,
  onStartRename,
  onRenamingValueChange,
  onConfirmRename,
  onCancelRename
}) => {

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onConfirmRename?.()
    } else if (e.key === 'Escape') {
      onCancelRename?.()
    }
  }

  return (
    <>
      {isRenaming ? (
        <div className={styles.renameContainer}>
          <input
            type="text"
            value={renamingValue}
            onChange={(e) => onRenamingValueChange?.(e.target.value)}
            onKeyDown={handleKeyDown}
            onBlur={onConfirmRename}
            className={styles.renameInput}
            autoFocus
          />
        </div>
      ) : (
        <h1 className={styles.lessonTitle}>
          {lessonName}
          {onStartRename && (
            <button className={styles.renameLink} onClick={onStartRename}>Rename</button>
          )}
        </h1>
      )}
      <LessonReadyRow
        allApproved={allApproved}
        unapprovedCount={unapprovedCount}
        teachStatus={teachStatus}
        isClassAssigned={isClassAssigned}
        assignedClassName={assignedClassName}
        onAssignClass={() => setShowAssignClassOverlay(true)}
        onLaunchLesson={onLaunchLesson}
      />
      <header>
        <div className="lesson-info">
          {assignedClassName && (
            <div className="class-info-line">
              Class: {assignedClassName}
              {gradeBand && <span className="grade-band-info"> (Grades {gradeBand})</span>}
              {(isClassAssigned || !!assignedClassName) && !hasResults && (
                <button className={styles.reassignButton} onClick={onReassign}>Reassign</button>
              )}
            </div>
          )}
        </div>
        <LessonOptionsDropdown
          isClassAssigned={isClassAssigned}
          assignedClassName={assignedClassName}
          lessonStatus={teachStatus}
          onShowStudentLogins={onShowStudentLogins}
          onCopyToClass={onCopyToClass}
          onPrintDraft={onPrintDraft}
          onPrintAnswerKey={onPrintAnswerKey}
          onPrintWorksheets={onPrintWorksheets}
        />
      </header>
    </>
  )
}
